"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var translate_1 = require("./translate");
function getCurrencySymbol(locale, options) {
    var delimiters = ',.';
    var directionControlCharacters = /[\u200E\u200F]/;
    var numReg = new RegExp("0[" + delimiters + "]*0*");
    var currencyStringRaw = formatCurrency(0, locale, options);
    var currencyString = currencyStringRaw.replace(directionControlCharacters, '');
    var matchResult = numReg.exec(currencyString);
    if (!matchResult) {
        throw new Error("Number input in locale " + locale + " is currently not supported.");
    }
    var formattedAmount = matchResult[0];
    var _a = tslib_1.__read(currencyString.split(formattedAmount), 2), currencyPrefix = _a[0], currencySuffix = _a[1];
    var elements = {
        symbol: currencyPrefix || currencySuffix,
        prefixed: currencyPrefix !== '',
    };
    return elements;
}
exports.getCurrencySymbol = getCurrencySymbol;
function formatCurrency(amount, locale, options) {
    return translate_1.memoizedNumberFormatter(locale, tslib_1.__assign({ style: 'currency' }, options)).format(amount);
}
exports.formatCurrency = formatCurrency;
